module.exports = __webpack_public_path__ + "img/bg_secure.7f4eed5c.svg";